import Home from '~/layouts/Home';
import NotFound from '~/layouts/NotFound';
import Billing from '~/components/Billing';
import Faq from '~/layouts/components/Faq';
import Navigate from '~/components/Navigate';
import Terms from '~/layouts/components/Terms';
import Privacy from '~/layouts/components/Privacy';
import GarenaLogin from '~/components/GarenaLogin';
import PaymentMethod from '~/components/PaymentMethod';
import MobileAward from '~/components/Mobile/MobileAward';
import BillingAward from '~/components/Billing/BillingAward';
import FreeFireLogin from '~/components/Mobile/FreeFireLogin';
import ConfirmPayment from '~/components/Mobile/ConfirmPayment';
import BillingChannel from '~/components/Billing/BillingChannel';

const publicRoutes = [
    { path: '/faq', component: Faq },
    { path: '/terms', component: Terms },
    { path: '/privacy', component: Privacy },
    { path: '*', component: NotFound, layout: null },
    { path: '/', component: Navigate, layout: null },
    { path: '/freefire-login', component: FreeFireLogin },
    { path: '/garena-login/:code', component: GarenaLogin },

    { path: '/billing', component: Billing },
    { path: '/billing/:code', component: BillingChannel },
    { path: '/billing/:code/awards', component: BillingAward },
    { path: '/billing/:code/payment', component: ConfirmPayment },

    { path: '/app', component: Home },
    { path: '/app/:code', component: PaymentMethod },
    { path: '/app/:code/awards', component: MobileAward },
    { path: '/app/:code/payment', component: ConfirmPayment },
];

export default publicRoutes;
